import { Component } from 'react';

import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { PhoneNumberOption } from './PhoneNumberOption';
import messages from './SelectPhoneNumber.messages';
import styles from './SelectPhoneNumber.module.css';
import { Select } from '../../../../forms/select/index';
import { TDeserialisedPerson } from '../IdCheckVerificationModal.types';

export class SelectPhoneNumber extends Component<{
    name: string;
    disabled?: boolean;
    addNewNumber: () => void;
    options: TDeserialisedPerson['phones'];
}> {
    handleOnSelectChange = (
        value: { type: string; value: string },
        input: { onChange: (value: string) => void }
    ) => {
        if (value.type === 'ADD_NEW') {
            this.props.addNewNumber();
        } else {
            input.onChange(value.value);
        }
    };

    render() {
        const { name, disabled, addNewNumber } = this.props;

        return (
            <Select
                className={classNames(styles.SelectPhoneNumber, 'fs-exclude')}
                placeholder={<FormattedMessage {...messages.select} />}
                name={name}
                disabled={disabled}
                addNewNumber={addNewNumber}
                selectOptions={{
                    classNameSelect: styles.SelectPaymentMethodDropDown,
                    optionComponent: PhoneNumberOption,
                    onSelect: this.handleOnSelectChange,
                    ...this.props
                }}
            />
        );
    }
}
